import type {Language, PreviousExport, ExportsSortBy} from '@/types'

import React from 'react'
import {map, mergeAll} from 'ramda'
import GoCloudDownload from 'react-icons/lib/go/cloud-download'
import MdCloudOff from 'react-icons/lib/md/cloud-off'
import NoAvailableTableData from '@/elements/no-available-table-data'
import {connect} from 'react-redux'
import {portfoliosActions, uiActions, portfoliosSelectors, appSelectors} from '@/store'
import Pagination from '@/controls/pagination'
import {date} from '@/format'

type Props = {
  exports: Array<PreviousExport>,
  l: Language,
  getAttachment: (PreviousExport) => void,
  sortBy: (ExportsSortBy, string) => void,
  pageChange: (string) => void,
  langCode: string,
}

const getClassNameForSortBy = ({sortOptions}) => (column: ExportsSortBy) => {
  let classNames = ['sort-by']
  const {sortBy, sortDir} = sortOptions
  if (sortBy === column) {
    if (sortDir === 'asc') {
      classNames.push('drop-up')
    } else {
      classNames.push('drop-down')
    }
  }
  return classNames.join(' ')
}
const bytesToSize = (bytes) => {
  bytes = parseInt(bytes, 10)
  let sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB']
  if (bytes === 0) return '0 Byte'
  let i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10)
  return `${parseFloat((bytes / Math.pow(1024, i)).toFixed(2))}  ${sizes[i]}`
}

const renderRow = (getAttachment, l, langCode) => (previousExport: PreviousExport) =>
  <tr key={previousExport.historyId}>
    <td width='10%'>{previousExport.size === '0 bytes' ? <MdCloudOff />
      : <a id='download_export' onClick={() => getAttachment(previousExport)}><GoCloudDownload/></a>}</td>
    <td width='30%'>{previousExport.name}</td>
    <td width='20%'>{l(previousExport.type)}</td>
    <td width='20%' className='date-format'>
      {previousExport.exportDate && date(previousExport.exportDate, langCode)}
    </td>
    <td width='20%'>{bytesToSize(previousExport.size)}</td>
  </tr>

const renderRows = (getAttachment, l, langCode) => map(renderRow(getAttachment, l, langCode))

export const RawPreviousExports = (props: Props) =>
  <div className="monitoring-table-ctr">
    <h4>{props.l('Previous exports')}</h4>
    <table className={props.exports.length > 10 ? 'table table-condensed shrink' : 'table table-condensed'}>
      <thead>
        <tr className={props.exports.length === 0 ? 'disabled-header' : ''} height="48">
          <th width='10%'></th>
          <th width='30%'><a onClick={() => props.exports.length > 0 ? props.sortBy('name', 'previous') : null}>{props.l('Export Name')}<span className={getClassNameForSortBy(props)('name')}></span></a></th>
          <th width='20%'><a onClick={() => props.exports.length > 0 ? props.sortBy('type', 'previous') : null}>{props.l('Type')}<span className={getClassNameForSortBy(props)('type')}></span></a></th>
          <th width='20%'><a onClick={() => props.exports.length > 0 ? props.sortBy('exportDate', 'previous') : null}>{props.l('Export Date')}<span className={getClassNameForSortBy(props)('exportDate')}></span></a></th>
          <th width='20%'>{props.l('Size')}</th>
        </tr>
      </thead>
    </table>
    <div className="tbody-scroll">
      <table className="table table-condensed" style={{position: 'relative'}}>
        <tbody>
          {props.exports.length === 0
            ? <NoAvailableTableData numOfCols={8} text={props.l('There are no previous exports')}/>
            : renderRows(props.getAttachment, props.l, props.langCode)(props.exports)}
        </tbody>
      </table>
    </div>
    {
      props.previousExportsCount > props.paging.pageSize ? <Pagination
        activePage={props.paging.pageNumber + 1}
        pageSize={props.paging.pageSize}
        totalItems={props.previousExportsCount}
        onChange={props.pageChange('previous')}
      /> : false
    }
  </div>

const mapStateToProps = (state) => ({
  paging: state.ui.previousExportsPaging,
  sortOptions: state.ui.previousExportsSortOptions,
  previousExportsCount: portfoliosSelectors.getActivePortfolioPreviousExportsCount(state),
  l: appSelectors.getL(state),
  langCode: state.app.user.preferredLanguageCode,
})

export default connect(
  mapStateToProps,
  mergeAll([portfoliosActions, uiActions])
)(RawPreviousExports)



// WEBPACK FOOTER //
// ./src/views/exports-page/previous-exports.js